import { useMemo } from 'react';
import { mapValues, pick } from 'lodash';
import { DASHBOARD_RANGE_PICKER_PRESETS } from 'taboola-ultimate-ui';
import { useAvailableItems } from 'hooks';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isDynamicReport } from '../../../config/isStaticDynamicReport';
import { useSelectedReportId } from './useSelectedReportId';

const presetConditions = {
    [DASHBOARD_RANGE_PICKER_PRESETS.TODAY]: {
        visibilityCondition: ({ accountConfig, isDynamic }) =>
            !isDynamic || (isDynamic && accountConfig[FEATURE_FLAGS.DYNAMIC_REPORTS_TODAY_PRESET_ENABLED] === 'true'),
    },
};

export const useAvailablePresetConfigs = presetConfigs => {
    const [reportId] = useSelectedReportId();
    const isDynamic = isDynamicReport(reportId);

    const presetConditionsMap = useMemo(() => {
        return mapValues(presetConfigs, (config, key) => ({
            id: key,
            ...(presetConditions[key] || {}),
        }));
    }, [presetConfigs]);

    const availablePresetItems = useAvailableItems(Object.values(presetConditionsMap), {
        isDynamic,
    });

    const availablePresetConfigs = useMemo(() => {
        const availableKeys = availablePresetItems.map(item => item.id);
        return pick(presetConfigs, availableKeys);
    }, [presetConfigs, availablePresetItems]);

    return availablePresetConfigs;
};
